var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A star icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {'filled' | 'hollow'} [props.variant]
 * @param {import('./sizes').IconSize} [props.size] The icon size.
 */
export default function StarIcon(_a) {
    var { size = 'small', variant = 'filled' } = _a, rest = __rest(_a, ["size", "variant"]);
    if (variant === 'hollow') {
        return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
                width: sizes[size],
                height: sizes[size],
                verticalAlign: 'sub',
            }, fill: "none", viewBox: "0 0 50 50" }, rest),
            jsx("path", { fill: "white", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M25.084 40.028l-14.37 7.525 2.745-15.939L1.834 20.327 17.899 18 25.084 3.5l7.185 14.501 16.065 2.326-11.625 11.287 2.744 15.939-14.369-7.525z", clipRule: "evenodd" })));
    }
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'sub',
        }, viewBox: "0 0 20 20", fill: "none" }, rest),
        jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.785 15.644l-5.738 3.017 1.096-6.39L.5 7.746l6.416-.932L9.785 1l2.87 5.814 6.415.932-4.643 4.525 1.096 6.39-5.738-3.017z", clipRule: "evenodd" })));
}
//# sourceMappingURL=StarIcon.js.map